import { initializeApp } from 'firebase/app'
import { getFirestore, collection, doc, getDoc, getDocs, addDoc, query, where, onSnapshot, updateDoc } from 'firebase/firestore'
var lastAddedDocId = null;
export const firebaseApp = initializeApp({
    apiKey: "AIzaSyA25MPVIFsl1l3UczzZXGmfq-cGn137kfw",
    authDomain: "tazej-ddf10.firebaseapp.com",
    databaseURL: "https://tazej-ddf10-default-rtdb.firebaseio.com",
    projectId: "tazej-ddf10",
    storageBucket: "tazej-ddf10.appspot.com",
    messagingSenderId: "11017125420",
    appId: "1:11017125420:web:48bb891756466e3ce5db89",
    // GA4 web: GTM + dataLayer (G-X5DNDBM4XP) — see src/helpers/analytics.js and docs/GOOGLE_TAGS.md.
    // Omit measurementId so Firebase Analytics is never initialized on web (no duplicate streams).
})

// used for the firestore refs
const db = getFirestore(firebaseApp)

// here we can export reusable database references
export const todosRef = collection(db, 'todos')


// Function to save a new record in the 'orders' collection
export async function saveOrder(orderData) {

    try {
        const ordersCollectionRef = collection(db, 'orders');
        orderData.auth_key = import.meta.env.VITE_FIREBASE_AUTH_KEY;
        
        const docRef = await addDoc(ordersCollectionRef, orderData);
        lastAddedDocId = docRef.id; // Store the last added document ID
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error('Error adding document: ', error);
        return { success: false, error: error.message };
    }
}

// Function to get an order by ID
export async function getOrderById(orderId) {
    try {
        const orderDocRef = doc(db, 'orders', orderId);
        const orderDoc = await getDoc(orderDocRef);

        if (orderDoc.exists()) {
            return { success: true, data: { id: orderDoc.id, ...orderDoc.data() } };
        } else {
            return { success: false, error: 'Order not found' };
        }
    } catch (error) {
        console.error('Error fetching order: ', error);
        return { success: false, error: error.message };
    }
}

// Function to get an order by the 'order_id' field
export async function getOrderByOrderId(orderId) {
    orderId = orderId.toString();
    try {
        const ordersCollectionRef = collection(db, 'orders');
        const q = query(ordersCollectionRef, where('order_id', '==', orderId));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            // Assuming 'order_id' is unique, return the first matching document
            const doc = querySnapshot.docs[0];
            return { success: true, data: { id: doc.id, ...doc.data() } };
        } else {
            return { success: false, error: 'Order not found' };
        }
    } catch (error) {
        console.error('Error fetching order by order_id: ', error);
        return { success: false, error: error.message };
    }
}

// Function to update a document in the 'orders' collection by 'order_id'
export async function updateOrderByOrderId(orderId, updatedData) {
    orderId = orderId.toString();
    try {
        const ordersCollectionRef = collection(db, 'orders');
        updatedData.auth_key = import.meta.env.VITE_FIREBASE_AUTH_KEY;

        const q = query(ordersCollectionRef, where('order_id', '==', orderId));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            // Assuming 'order_id' is unique, update the first matching document
            const docRef = querySnapshot.docs[0].ref;
            await updateDoc(docRef, updatedData); // Use updateDoc here
            return { success: true };
        } else {
            return { success: false, error: 'Order not found' };
        }
    } catch (error) {
        console.error('Error updating order by order_id: ', error);
        return { success: false, error: error.message };
    }
}

// Function to watch a document by 'order_id' and detect changes to the 'status' field (Callback-based)
export function watchOrderStatusByOrderId(orderId, callback) {
    orderId = orderId.toString();
    try {
        const ordersCollectionRef = collection(db, 'orders');
        const q = query(ordersCollectionRef, where('order_id', '==', orderId));

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            if (!querySnapshot.empty) {
                const doc = querySnapshot.docs[0]; // Assuming 'order_id' is unique
                const data = doc.data();
                callback(null, { id: doc.id, status: data.status });
            } else {
                callback('No document found with the specified order_id', null);
            }
        }, (error) => {
            callback(error, null);
        });

        return unsubscribe; // Return the unsubscribe function to stop listening when needed
    } catch (error) {
        callback(error, null);
    }
}

// Function to get the last added order
export async function getLastOrder() {
    try {
        if (!lastAddedDocId) {
            return { success: false, error: 'No order has been added yet' };
        }

        const orderDocRef = doc(db, 'orders', lastAddedDocId);
        const orderDoc = await getDoc(orderDocRef);

        if (orderDoc.exists()) {
            return { success: true, data: { id: orderDoc.id, ...orderDoc.data() } };
        } else {
            return { success: false, error: 'Last order not found' };
        }
    } catch (error) {
        console.error('Error fetching last order: ', error);
        return { success: false, error: error.message };
    }
}

